import "./button.css";

function Buttons() {
  return (
    <div className="container button-container">
      <a href="#about" className="btn pri">
        Know more
      </a>
      <a href="#contact" className="btn sec">
        Keep in Touch
      </a>
    </div>
  );
}

export default Buttons;
